import { useTranslation } from '@kostbar/i18n'
import { Badge } from '@/components/ui/badge'
import { useAuth } from '@/features/auth/hooks/use-auth'

const roleColors: Record<
  string,
  'default' | 'secondary' | 'destructive' | 'outline'
> = {
  SUPER_ADMIN: 'destructive',
  TENANT_ADMIN: 'default',
  MANAGER: 'secondary',
  ASSISTANT: 'outline',
}

export function RoleBadges() {
  const { t: tProfile } = useTranslation('profile')
  const { user } = useAuth()

  if (!user || user.roles.length === 0) {
    return null
  }

  return (
    <div>
      <label className="text-sm font-medium text-muted-foreground mb-2 block">
        {tProfile('roles')}
      </label>
      <div className="flex flex-wrap gap-2">
        {user.roles.map((role) => (
          <Badge key={role} variant={roleColors[role]}>
            {role.replace('_', ' ')}
          </Badge>
        ))}
      </div>
    </div>
  )
}
